/**
 * @param lower  lowest possible value inclusive
 * @param upper largest possible value inclusive
 * @returns randomBetween whole number between parameters inclusive
 */
export function randomBetween(lower: number, upper: number) {
  return lower + Math.floor(Math.random() * (upper - lower + 1));
}
